"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Modal_1 = __importDefault(require("@/Jetstream/Modal"));
JetConfirmationModal.Content = function JetConfirmationModalContent(_a) {
    var title = _a.title, children = _a.children;
    return (react_1.default.createElement("div", { className: "bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4" },
        react_1.default.createElement("div", { className: "sm:flex sm:items-start" },
            react_1.default.createElement("div", { className: "mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10" },
                react_1.default.createElement("svg", { className: "h-6 w-6 text-red-600", stroke: "currentColor", fill: "none", viewBox: "0 0 24 24" },
                    react_1.default.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" }))),
            react_1.default.createElement("div", { className: "mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left" },
                react_1.default.createElement("h3", { className: "text-lg" }, title),
                react_1.default.createElement("div", { className: "mt-2" }, children)))));
};
JetConfirmationModal.Footer = function JetConfirmationModalFooter(_a) {
    var children = _a.children;
    return react_1.default.createElement("div", { className: "px-6 py-4 bg-gray-100 text-right" }, children);
};
function JetConfirmationModal(_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return react_1.default.createElement(Modal_1.default, __assign({}, props), children);
}
exports.default = JetConfirmationModal;
